import { defineMessages } from 'react-intl';

export default defineMessages({
    requiredSignatures: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Required Signatures',
        defaultMessage: 'Required Signatures'
    },
    forms: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Forms',
        defaultMessage: 'Forms'
    },
    signatureTypeMustSelect: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.signatureTypeMustSelect',
        defaultMessage: 'Signature Type must be selected for each form'
    },
    form: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Form',
        defaultMessage: 'Form'
    },
    signatureType: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Signature Type',
        defaultMessage: 'Signature Type'
    },
    actions: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Actions',
        defaultMessage: 'Actions'
    },
    faxNumber: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Fax Number',
        defaultMessage: 'Fax Number'
    },
    enterEmail: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Enter email',
        defaultMessage: 'Enter {name}\'s email'
    },
    sentToMailing: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.sentToMailing',
        defaultMessage: 'This form will be sent to your mailing address.'
    },
    availableForDownload: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.availableForDownload',
        defaultMessage: 'This form will be available for download on next screen.'
    },
    phoneNumberPlaceholder: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.phoneNumberPlaceholder',
        defaultMessage: '(###) ###-####'
    },
    namedInsuredEmail: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Named insured email',
        defaultMessage: 'Named insured email'
    },
    secondaryNamedInsuredEmail: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Secondary Named Insured Email',
        defaultMessage: 'Secondary Named Insured Email'
    },
    excludedDriverEmail: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Excluded Driver Email',
        defaultMessage: 'Excluded Driver Email'
    },
    spouseEmail: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Spouse Email',
        defaultMessage: 'Spouse Email'
    },
    secondEmail: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Second Email',
        defaultMessage: 'Second Email'
    },
    duplicateEmail: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.duplicateEmail',
        defaultMessage: 'Each customer must have a unique email address.'
    },
    secondMobileNumber: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Secondary Named Insured Mobile Number',
        defaultMessage: 'Secondary Named Insured Mobile Number'
    },
    excludedMobileNumber: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Excluded Driver Mobile Number',
        defaultMessage: 'Excluded Driver Mobile Number'
    },
    enterMobileNumber: {
        id: 'ml.gateway.endorsement.common.requiredSignatures.Enter Mobile Number',
        defaultMessage: 'Enter {name}\'s Mobile Number'
    },
})